module.exports = __webpack_public_path__ + "img/已入驻牛超市(家).532e4ece.png";